
export interface AmountVerifyRequest {
  expectedAmount: number;
  orderId: string;
}
